import React, { useEffect, useState, useRef } from "react";
import "./VerificationPage.css";
// import { DatePicker } from "antd";
// import { Select } from "antd";
import {
  backendApi,
  callPlayBot,
  CompleteApi,
  fetchCustomApi,
  fetchCustomApiWithToken,
  LiveCallApi
} from "../../services/service";
import LoaderComp from "../../LoaderComp";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { addToken, getCallId, getInitialData } from "../../Redux/UserSlice";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import inLocale from "date-fns/locale/en-IN";

const VerificationPage = ({ setPage, languageContent, userData }) => {

  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const [showDate, setShowDate] = useState(false);
  const [liveCallResponse, setLiveCallResponse] = useState(false)
  const dispatch = useDispatch();
  const call_id = useSelector(getCallId);

  let nudge30SecondTimer = useRef(null)
  let nudge60SecondTimer = useRef(null)

  const submitapi = async (call_id, key, value) => {
    await backendApi(call_id, key, value)
      .then((res) => {
        if (res.data) {
          // setPage("verification");
          console.log(res.data);
        } else {
          setPage("landing");
        }
      })
      .catch(() => setPage("landing"));
  };
  const mediaApi = async (call_id, action) => {
    await callPlayBot(call_id, action)
      .then((res) => {
        console.log(res.data);
      })
      .catch((e) => console.log(e.message));
  };
  const template_nudge = () => {
    callPlayBot(call_id, "no_input_nudge")
      .then((res) => console.log(res.data))
      .catch((e) => console.log(e.message));
  }
  const clearNudgeTimers = () => {
    clearTimeout(nudge30SecondTimer)
    clearTimeout(nudge60SecondTimer)
  }
  const liveCallApi = async (call_id) => {
    await LiveCallApi(call_id)
      .then((res) => {
        console.log(res.data);
        if (res.data === false) {
          // if (userData.flow_type && userData.flow_type.toLowerCase() === "hdfc") {
          //   setPage('callDisconnected')
          // }
        }
        setLiveCallResponse(true)
      })
      .catch((e) => {
        setPage("sorryPage");
      });
  }

  useEffect(() => {
      liveCallApi(call_id)
    nudge30SecondTimer = setTimeout(() => template_nudge(), 30000);
    nudge60SecondTimer = setTimeout(() => template_nudge(), 60000);
    mediaApi(call_id, "verification_page");
    submitapi(call_id, "verification_page", "open");


    return () => {
      clearNudgeTimers();
    }
  }, []);

  const [verifieduserData, setVerifiedUserData] = useState({
    dob: "",
    msisdn: "",
  });
  function onChange(date, dateString) {
    console.log(date, dateString);
    setVerifiedUserData({
      ...verifieduserData,
      dob: dateString,
    });
  }
  const [valueGroups, setValueGroups] = useState({
    year: "1990",
    month: "04",
    day: "07",
  });


  const handleInput = (e) => {
    clearNudgeTimers();
    setVerifiedUserData({
      ...verifieduserData,
      msisdn: e.target.value,
    });
  };
  const [count, setCount] = useState(0);
  const handleVerificationSubmit = async () => {
    clearNudgeTimers();
    let newf = moment(new Date(mdate)).format("YYYY-MM-DD")
    let vdata = {
      dob: newf,
      msisdn: verifieduserData.msisdn,
    };
    if (vdata.dob === "") {
      setError(languageContent.verification_page.wrongDate);
      mediaApi(call_id, "wrong_dob")
        .then((res) => {
          console.log(res.data);
        })
        .catch((e) => console.log(e.message));
      return;
    }
    if (vdata.msisdn === "") {
      setError(languageContent.verification_page.wrongPhone);
      mediaApi(call_id, "wrong_phone")
        .then((res) => {
          console.log(res.data);
        })
        .catch((e) => console.log(e.message));
      return;
    }
    let tokenData = {};
    setError("");
    setLoader(true);
    console.log(verifieduserData);
    await fetchCustomApi(call_id, "POST", `validate/${call_id}`, vdata)
      .then((data) => {
        tokenData = data.data;
        setCount(count + 1);
        dispatch(addToken(tokenData.token));
        if (tokenData.token) {
          submitapi(call_id, "page_1_verification", "success")
            .then((res) => console.log(res.data))
            .catch((e) => console.log(e.message));
          fetchCustomApiWithToken(
            call_id,
            "GET",
            `sendOTP/${call_id}`,
            {},
            tokenData.token
          )
            .then((res) => {
              if (res.status === 200) {
                setPage("otp");
              }
            })
            .catch((e) => console.log(e.message));
        } else {
          submitapi(call_id, "page_1_verification", "failed")
            .then((res) => console.log(res.data))
            .catch((e) => console.log(e.message));
          if (count > 1) {
            CompleteApi(call_id, "incorrect_details")
              .then((res) => {
                console.log(res.data);
                setPage("sorryPageAttempt");
              })
              .catch((e) => {
                console.log(e.data);
                setPage("sorryPageAttempt");
              });
            return;
          }
          switch (tokenData.reason) {
            case "INVALID_MSISDN":
              mediaApi(call_id, "wrong_phone")
                .then((res) => {
                  console.log(res.data);
                })
                .catch((e) => {
                  console.log(e.message);
                });
              setError(languageContent.verification_page.wrongPhone);
              break;
            case "INVALID_DOB":
              mediaApi(call_id, "wrong_dob")
                .then((res) => {
                  console.log(res.data);
                })
                .catch((e) => {
                  console.log(e.message);
                });
              setError(languageContent.verification_page.wrongDate);
              break;
            case "INVALID_LANGUAGE":
              mediaApi(call_id, "wrong_language")
                .then((res) => {
                  console.log(res.data);
                })
                .catch((e) => {
                  console.log(e.message);
                });
              setError(languageContent.verification_page.wrongLanguage);
              break;
          }
        }

        // setPage("otp");
      })
      .catch((e) => console.log(e.message))
      .finally(() => {
        setLoader(false);
        // setPage("otp");
      });
  };
  const [mdate, setMDate] = useState(new Date());
  return (
    liveCallResponse ?
    <>
      <div className="heading">
        <img src="./immigration.png" className="imageImmigration" alt="Img" />
        <p>{languageContent.verification_page.verification_title}</p>
      </div>
      <hr></hr>

      {
      // (userData.flow_type && userData.flow_type.toLowerCase() === "hdfc") ? null :
        <>
          <p>{languageContent.verification_page.verification_sub_title}</p>
          <p>{languageContent.verification_page.verify_dob}</p>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={inLocale}>
            <DatePicker
              style={{ padding: "14px" }}
              maxDate={new Date()}
              value={mdate}
              onChange={(newValue) => {
                console.log(newValue);
                // let newf = moment(new Date(newValue)).format("YYYY-MM-DD");
                // console.log(newf);
                setMDate(newValue);
              }}
              renderInput={(params) => (
                <TextField placeholder="DD/MM/YYYY" fullWidth {...params} />
              )}
            />
          </LocalizationProvider>

        </>}

      <p>{languageContent.verification_page.verify_phone}</p>
      <TextField
        fullWidth
        placeholder="XXXXXXXXXX"
        name="msisdn"
        type="tel"
        onChange={handleInput}
        maxLength="10"
      // inputProps={{ maxLength: 10 }}
      />
      <button
        onClick={handleVerificationSubmit}
        className="myButton"
        style={{ marginTop: "4rem" }}
      >
        {languageContent.buttons.submit}
      </button>
      {
      // (userData.flow_type && userData.flow_type.toLowerCase() === "hdfc") ?
       <p>{languageContent.verification_page.otp_disclaimer}</p> 
      //  : null
       }

      <br />
      {error && <p>{error}</p>}
      {loader && <LoaderComp /> }
    </>: <LoaderComp />

  
    
  );
};

export default VerificationPage;
